// extracted by mini-css-extract-plugin
export var mt0 = "widget-markdown-module--mt-0--605a5";
export var mt1 = "widget-markdown-module--mt-1--ecb27";
export var mt2 = "widget-markdown-module--mt-2--f58a1";
export var mt3 = "widget-markdown-module--mt-3--6a128";
export var mt4 = "widget-markdown-module--mt-4--bd71b";
export var mt5 = "widget-markdown-module--mt-5--45eaf";
export var mt6 = "widget-markdown-module--mt-6--58b9b";
export var widgetMarkdown = "widget-markdown-module--widget-markdown--c29a5";
export var widgetMarkdown__markdown = "widget-markdown-module--widget-markdown__markdown--94e23";